import Vue from 'vue'
import vfmPlugin from 'vue-final-modal'

Vue.use(vfmPlugin)
